/**
 * @description 常量定义
 * @author aprilcai
 */

// sdk版本定义
export const version = PACKAGE_VERSION;

// 返回错误码定义
export enum resultCode {
  ok = 0,
  notFound = -1,
  notSupport = -2,
  notAllow = -3,
  error = -4,
  cancel = -5,
  noLogin = 6,
  timeout = 7,
  platformNotSupport = 8
}

// 返回错误信息定义
export enum resultMessage {
  ok = 'ok',
  notFound = 'method not found',
  notSupport = 'method not support',
  notAllow = 'method not allow',
  error = 'method invoke error',
  cancel = 'method invoke cancel',
  noLogin = 'no login',
  timeout = 'timeout',
  platformNotSupport = 'current platform/page/host is not support this method'
}

// 包装结果
export function wrapResult(code: number, msg: string, result: any = {}) {
  return {
    code,
    msg,
    result,
  };
}

export const zeptoJsUrl = '//vm.gtimg.cn/c/=/tencentwap/js/zepto.1.1.6.js';

export const h5LoginModuleJSUrl = '//vm.gtimg.cn/tencentvideo/script/film/common/lib/login.js';

export const payUrl = '//vm.gtimg.cn/tencentvideo_v1/js/film/ipay_v3/api/minipay.openapi.min.js';

export const filmPayUrl = 'https://film.qq.com/weixin/v3/diamond/index.html';

export const noSleepUrl = '//comps.videohudong.com/lib/nosleep.min.js';

export const athenaJsUrl = '//mat1.gtimg.com/gamezone/iwan/athena/min/athena.min.js';

export const athenaCssUrl = '//mat1.gtimg.com/gamezone/iwan/athena/min/athena.css';
